import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { hasLocizeTranslation } from 'lib/utils/locize'
import { withI18next } from 'lib/i18n/withI18next'
import compose from 'recompose/compose'
import Typo from 'constants/typography'
import Icon from 'components/common/icon'
import { ICON_SIZE } from 'components/common/icon/const'
import { connect } from 'react-redux'
import getConfiguration from 'lib/api/configuration'
import ResponsiveImage from 'components/images/responsive-image'
import Button from 'components/common/button'
import { BUTTON_TYPES } from 'constants/button'
import { bindActionCreators } from 'redux'
import CartDuck from 'components/cart/duck'
import Loader from 'components/loader'
import cartItemsDuck from 'components/cart/cart-items/duck'
import Router from 'next/router'
import StateStorage from 'lib/state-storage'
import styles from './subscribe-diamond-section-card.scss'
import useAddDiamondToCart from '../useEffect/useAddDiamondToCart/useAddDiamondToCart'

export const SubscribeDiamondSectionCard = ({
  t,
  refType,
  compact,
  isPhone,
  addToCart,
  updateCart,
  applyStoreCredit,
}) => {
  const [loyaltyData, setLoyaltyData] = useState(null)
  const { handleClickAddToCart, isAddingCart } = useAddDiamondToCart({
    refType,
    addToCart,
    updateCart,
    id_product: loyaltyData?.diamond_product?.id_product,
    id_product_attribute: loyaltyData?.diamond_product?.id_product_attribute,
    applyStoreCredit,
  })
  const shop = StateStorage.getShop()
  const language = StateStorage.getLanguage()
  const backgroundImage = loyaltyData?.banner_image_full_url
  const tierColor = loyaltyData?.tier_color

  useEffect(() => {
    const fetchLoyaltyData = async () => {
      try {
        const res = await getConfiguration({
          name: 'LoyaltyDiamondExclusiveContent_20260114',
        })
        if (res) {
          setLoyaltyData(res?.configuration)
        }
      } catch (e) {
        // eslint-disable-next-line
        console.error(e)
      }
    }

    fetchLoyaltyData()
  }, [])

  if (!loyaltyData) {
    return (
      <div className="loader-container">
        <Loader />
      </div>
    )
  }

  if (compact) {
    const thai = language === 'th'
    return (
      <section className="diamond-compact">
        <style jsx>{styles}</style>
        <strong>
          {hasLocizeTranslation(
            t,
            'CART_DIAMOND_BENEFIT',
            thai ? 'รับส่วนลด 8% สำหรับคำสั่งซื้อนี้' : 'Get 8% off this order',
          )}
        </strong>
        <span>
          {hasLocizeTranslation(
            t,
            'CART_DIAMOND_VOUCHER',
            thai ? '+ คูปองซื้อ 1 แถม 1' : '+ a Buy 1 Get 1 voucher',
          )}
        </span>
        <small>
          {hasLocizeTranslation(
            t,
            'CART_DIAMOND_ELIGIBILITY',
            thai
              ? 'สำหรับสินค้าที่ร่วมรายการ ตามเงื่อนไขสมาชิก'
              : 'On eligible items. Membership terms apply.',
          )}
        </small>
        <span>
          {hasLocizeTranslation(
            t,
            loyaltyData?.diamond_product_subscription_price_key,
            thai ? '฿999 ต่อปี' : '฿999 billed yearly',
          )}
        </span>
        <Button
          type={BUTTON_TYPES.primary}
          onClick={handleClickAddToCart}
          disabled={
            isAddingCart ||
            !loyaltyData?.diamond_product?.id_product ||
            !loyaltyData?.diamond_product?.id_product_attribute
          }
        >
          {isAddingCart ? (
            <Loader small />
          ) : (
            hasLocizeTranslation(
              t,
              'CART_ADD_MEMBERSHIP',
              thai ? 'เพิ่มสมาชิก Diamond' : 'Add Diamond membership',
            )
          )}
        </Button>
        <Button
          type={BUTTON_TYPES.textDark}
          onClick={() =>
            Router.push(`/${shop}/${language}/loyalty-diamond`, {
              pathname: '/loyalty-diamond',
            })
          }
        >
          {hasLocizeTranslation(t, 'LEARN MORE', 'LEARN MORE')}
        </Button>
      </section>
    )
  }

  return (
    <React.Fragment>
      <style jsx>{styles}</style>
      <div className="subscribe-diamond-section-card">
        <ResponsiveImage
          src={backgroundImage ?? ''}
          imgRatio={isPhone ? 1.78 : 3.13}
          alt={t('diamond-section-banner')}
          className="subscribe-diamond-section-card__image"
        />
        <div className={clsx('subscribe-diamond-section-card__info')}>
          <div className={clsx(Typo.subtitle1)}>
            {hasLocizeTranslation(
              t,
              loyaltyData?.banner_title_key,
              'Exclusive Diamond savings, all year long.',
            )}
          </div>
          <div
            className={clsx('subscribe-diamond-section-card__info__benefits')}
          >
            {loyaltyData?.summary_benefits?.map(
              ({ icon_url_white, title_key }) => (
                <div
                  key={title_key}
                  className="subscribe-diamond-section-card__info__benefits__content"
                >
                  <Icon
                    className="subscribe-diamond-section-card__info__benefits__icon"
                    size={ICON_SIZE.medium}
                    src={icon_url_white}
                  />
                  <div className={Typo.caption}>
                    {hasLocizeTranslation(t, title_key, title_key)}
                  </div>
                </div>
              ),
            )}
          </div>
          <div>
            <div className={Typo.caption}>
              {hasLocizeTranslation(
                t,
                loyaltyData?.diamond_product_subscription_price_key,
                '฿84/month (฿999 billed yearly)',
              )}
            </div>
            <Button
              type={BUTTON_TYPES.textDark}
              style={{ color: tierColor }}
              className="subscribe-diamond-section-card__info__cta-button"
              onClick={handleClickAddToCart}
            >
              {isAddingCart ? (
                <Loader small />
              ) : (
                hasLocizeTranslation(t, 'BUY_&_USE_NOW', 'BUY & USE NOW')
              )}
            </Button>
            <Button
              onClick={() =>
                Router.push(`/${shop}/${language}/loyalty-diamond`, {
                  pathname: `/loyalty-diamond`,
                })
              }
              type={BUTTON_TYPES.textDark}
            >
              {hasLocizeTranslation(t, 'LEARN MORE', 'LEARN MORE')}
            </Button>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

SubscribeDiamondSectionCard.defaultProps = {
  applyStoreCredit: undefined,
  compact: false,
}

SubscribeDiamondSectionCard.propTypes = {
  compact: PropTypes.bool,
  // component props
  t: PropTypes.func.isRequired,
  applyStoreCredit: PropTypes.bool,
  isPhone: PropTypes.bool.isRequired,
  addToCart: PropTypes.func.isRequired,
  refType: PropTypes.string.isRequired,
  updateCart: PropTypes.func.isRequired,
}

export default compose(
  connect(
    (state) => ({
      isPhone: state.device.isPhone,
      applyStoreCredit: state.cartData.isStoreCreditUsed,
    }),
    (dispatch) =>
      bindActionCreators(
        {
          addToCart: CartDuck.creators.get,
          updateCart: cartItemsDuck.creators.update,
        },
        dispatch,
      ),
  ),
  withI18next(),
)(SubscribeDiamondSectionCard)
